import { combineReducers } from 'redux';
import general from 'app/redux/features/pad-initialization/reducer/general.reducer';
import visitScheduleStep from 'app/redux/features/pad-initialization/reducer/visit-schedule-step/visitScheduleStep.reducer';
import calendar from 'app/redux/features/pad-initialization/reducer/visit-schedule-step/calendar.reducer';
import viewResponsibleStep from 'app/redux/features/pad-initialization/reducer/view-responsible-step/viewResponsibleStep.reducer';
import implantationScheduleStep from 'app/redux/features/pad-initialization/reducer/scheduleImplantationStep/scheduleImplantation.reducer';
import hospitalReleasePrevisionStep from 'app/redux/features/pad-initialization/reducer/hospitalReleasePrevisionStep/hospitalReleasePrevision.reducer';
import patientDischargeStep from 'app/redux/features/pad-initialization/reducer/dischargePatientStep/dischargePatient.reducer';
import prescriptionsScheduleStep from 'app/redux/features/pad-initialization/reducer/schedulePrescriptionsStep/schedulePrescriptions.reducer';
import visitsSuspensionStep from 'app/redux/features/pad-initialization/reducer/suspensionVisitsStep/suspensionVisits.reducer';
import feedback from 'app/redux/features/pad-initialization/reducer/feedback.reducer';
import schedulePrescriptionInfoModal from 'app/redux/features/pad-initialization/reducer/schedulePrescriptionsStep/modal/schedulePrescriptionInfo.reducer';
import schedulePrescriptionExhaustedModal from 'app/redux/features/pad-initialization/reducer/schedulePrescriptionsStep/schedule-prescription-modal/selectSchedulePrescriptionExhaustedModal.reducer';
import schedulePrescriptionUnlinkedItemsModal from 'app/redux/features/pad-initialization/reducer/schedulePrescriptionsStep/schedule-prescription-modal/schedulePrescriptionUnlinkedItemsModal.reducer';
import schedulePrescriptionIncompatibleLinkModal from 'app/redux/features/pad-initialization/reducer/schedulePrescriptionsStep/schedule-prescription-modal/schedulePrescriptionIncompatibleLinkModal.reducer';
/**
 * Root reducer for pad-initialization (flattened state shape).
 * This is the pure combined reducer without backward compatibility.
 * The state structure is:
 * {
 *   general,
 *   visitScheduleStep,
 *   implantationScheduleStep,
 *   hospitalReleasePrevisionStep,
 *   patientDischargeStep,
 *   prescriptionsScheduleStep,
 *   visitsSuspensionStep,
 *   calendar,
 *   feedback
 * }
 */
export default combineReducers({
  general,
  visitScheduleStep,
  viewResponsibleStep,
  implantationScheduleStep,
  hospitalReleasePrevisionStep,
  patientDischargeStep,
  prescriptionsScheduleStep,
  visitsSuspensionStep,
  calendar,
  feedback,
  schedulePrescriptionInfoModal,
  schedulePrescriptionExhaustedModal,
  schedulePrescriptionUnlinkedItemsModal,
  schedulePrescriptionIncompatibleLinkModal
});
